import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';

import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { AnimatedGrid } from '../../components/AnimatedSection';
import CommonTitle from '../../components/CommonTitle';
import getLocal from 'eco-design-reliance/getLocal';

export default function SectionImageText() {
    const { t } = useLang('SectionImageText2');
    const { locale = 'us' } = getLocal();
    return (
        <div className={`page-SectionImageText2 ${styles.SectionImageText2} GtmModuleData-section`} id='SectionImageText2' data-section-id="d3c-SectionImageText2">
            <CommonTitle
                title={t('title')}
                desc={t.rich('desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                })}
            />
            <EcoSpaceSmall />
            <AnimatedGrid variant="fadeInUp" options={{ stagger: 0.2, delay: 200, threshold: 0.2 }}>
                <div className={`eco-content ${styles.SectionImageText}`}>
                    <EcoImg
                        pc={locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1773904659595/pc-222.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1773904549868/pc-2-2.jpg'}
                        h5={locale === 'uk' ? 'https://websiteoss.ecoflow.com/upload/image/1773904663656/m-222.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1773904549443/m-2-2.jpg'}
                        isOpenLazy={true}
                    />
                </div>
            </AnimatedGrid>
            <EcoSpace />
        </div>
    );
}
